module.exports = __webpack_public_path__ + "static/media/clip-detection-icon.0975397a.svg";